import { render } from "./LoginAttempts.vue?vue&type=template&id=8a294e50"
import script from "./LoginAttempts.vue?vue&type=script&lang=js"
export * from "./LoginAttempts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__